import PageLoading from 'app/components/UI-Elements/Feedback/loading/PageLoading'
import PageWrapper from 'app/components/UI-Elements/Layout/PageWrapper'
import { Routes } from 'app/constants/Routes'
import ErrorNotFound from 'app/pages/404/ErrorNotFound'
import PurchasingRequestLoading from 'app/pages/PurchasingRequest/Components/PurchasingLoading'
import PurchasingRequestResponse from 'app/pages/PurchasingRequest/Views/response'
import PurchasingRequestShowPage from 'app/pages/PurchasingRequest/Views/show'
import { getBaseRoutePath, retry } from 'app/util/Utilities'
import * as React from 'react'
import { lazy, Suspense } from 'react'
import { Route, Routes as Switch } from 'react-router-dom'

const Request = lazy(() => retry(() => import('../../pages/PurchasingRequest/Views/Request')))
const Finalize = lazy(() => retry(() => import('../../pages/FinalizeRentalRequest/Pages/Finalize')))
const Success = lazy(() => retry(() => import('../../pages/PurchasingRequest/Views/Success')))

const PurchasingRequestsPage = lazy(() =>
  retry(() => import('app/pages/PurchasingRequest/Views/index'))
)
const PurchasingServiceRequestPage = lazy(() =>
  retry(() => import('app/pages/PurchasingRequest/Views/service_request'))
)

const PurchasingRequestRoutes: React.FC = () => {
  return (
    <Switch>
      <Route
        key="finalize"
        path={Routes.PurchasingRequest.member(undefined, false).finalize}
        element={
          <Suspense fallback={<PageLoading />}>
            <Finalize />
          </Suspense>
        }
      />
      <Route
        key="availability"
        path={Routes.PurchasingRequest.member(undefined, false).availability}
        element={
          <Suspense fallback={<PageLoading />}>
            <PurchasingRequestLoading>
              <Request />
            </PurchasingRequestLoading>
          </Suspense>
        }
      />
      <Route
        key="availability-confirmation"
        path={Routes.PurchasingRequest.member(undefined, false).availability_confirmation}
        element={
          <Suspense fallback={<PageLoading />}>
            <PurchasingRequestLoading>
              <Success />
            </PurchasingRequestLoading>
          </Suspense>
        }
      />
      <Route
        key="purchasing-request-response"
        path={Routes.PurchasingRequest.member(undefined, false).response}
        element={
          <Suspense fallback={<PageLoading />}>
            <PurchasingRequestResponse />
          </Suspense>
        }
      />
      <Route
        path={Routes.PurchasingRequest.member(undefined, false).show}
        element={
          <Suspense fallback={<PageLoading />}>
            <PurchasingRequestShowPage />
          </Suspense>
        }
        key="purchasing-request-show"
      />
      <Route
        path={Routes.PurchasingRequest.member(undefined, false).service_request}
        element={
          <Suspense fallback={<PageLoading />}>
            <PurchasingRequestLoading>
              <PurchasingServiceRequestPage />
            </PurchasingRequestLoading>
          </Suspense>
        }
        key="purchasing-service-request-show"
      />
      <Route
        path={'/'}
        element={
          <Suspense fallback={null}>
            <PageWrapper>
              <PurchasingRequestsPage />
            </PageWrapper>
          </Suspense>
        }
        key="order-request-index-page"
      />
      <Route path={getBaseRoutePath('')} element={<ErrorNotFound />} />
    </Switch>
  )
}

export default PurchasingRequestRoutes
